module.exports = __webpack_public_path__ + "img/Nicole Pavao.48628502.jpg";